import React from 'react';
import './tabView.css'
import { get, postFormData } from '../../network/request'

class QuestionTabView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            userName: "User",
            questionHistory: [],
            currentQuestionIndex: 0,
            loading: false,
            isSubmitting: false,
            hasSubmittedToday: false,
            lastSubmitDate: null,
            answerQuestionIds: [],
            answerContents: []
        };
    }

    componentDidMount() {
        this.initUserInfo();
        this.checkTodaySubmission();
        this.getQuestionHistory();
    }

    initUserInfo() {
        let userInfo = localStorage.getItem("initUser");
        if (userInfo) {
            let userJson = JSON.parse(userInfo);
            this.setState({ userName: userJson["user_id"] || "User" });
        }
    }

    // 检查今天是否已经提交过
    checkTodaySubmission() {
        const today = new Date().toDateString();
        const lastSubmitDate = localStorage.getItem("questionSubmitDate");
        
        if (lastSubmitDate === today) {
            this.setState({ 
                hasSubmittedToday: true,
                lastSubmitDate: today
            });
        }
    }

    getQuestionHistory() {
        // 如果今天已经提交过，不获取题目
        if (this.state.hasSubmittedToday) {
            return;
        }

        this.setState({ loading: true });

        let userInfo = localStorage.getItem("initUser");
        let userJson = JSON.parse(userInfo);
        let userId = userJson["user_id"];
        let workType = userJson["selectType"] || "1";
        let sceneType = "1";

        get("/jobQuestion", {"userId": userId, "sceneType": sceneType})
            .then(response => {
                if (response && response["success"] === true && response.data) {
                    let questionHistory = response.data.map((item, index) => {
                        let questionArr = item.questionModel.questionArr.map((questionItem, qIndex) => {
                            return {
                                title: questionItem,
                                select: false,
                                question_type: item.question_type,
                                index: qIndex
                            }
                        });

                        return {
                            id: item.id,
                            question_id: item.question_id,
                            question_type: item.question_type,
                            question_type_name: Number(item.question_type) === 1 ? 'Single Choice' : 'Multiple Choice',
                            title: item.questionModel.title || `Question ${index + 1}`,
                            options: questionArr,
                            answered: false,
                            date: new Date().toLocaleDateString()
                        };
                    });

                    this.setState({
                        questionHistory: questionHistory,
                        loading: false
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                console.error("获取问题历史失败:", error);
                this.setState({ loading: false });
            });
    }

    handleOptionClick = (questionIndex, optionIndex) => {
        const { questionHistory, currentQuestionIndex } = this.state;
        const question = questionHistory[currentQuestionIndex];
        const isMultiselect = Number(question.question_type) === 2;

        if (isMultiselect) {
            // Multiple choice: toggle option
            question.options[optionIndex].select = !question.options[optionIndex].select;
        } else {
            // Single choice: can only select one
            question.options.forEach((opt, idx) => {
                opt.select = (idx === optionIndex);
            });
        }

        questionHistory[currentQuestionIndex] = question;

        this.setState({ questionHistory });
    }

    goToNextQuestion = () => {
        const { questionHistory, currentQuestionIndex } = this.state;
        const q = questionHistory[currentQuestionIndex];
        if (q) {
            const hasSelection = q.options.some((opt) => opt.select);
            if (!hasSelection) return;
        }
        if (currentQuestionIndex < questionHistory.length - 1) {
            this.setState({ currentQuestionIndex: currentQuestionIndex + 1 });
        }
    }

    goToPreviousQuestion = () => {
        const { currentQuestionIndex } = this.state;
        if (currentQuestionIndex > 0) {
            this.setState({ currentQuestionIndex: currentQuestionIndex - 1 });
        }
    }

    // 提交答案
    submitAnswers = () => {
        const { questionHistory, answerQuestionIds, answerContents } = this.state;
        
        // 收集所有已答题目的答案
        const allQuestionIds = [];
        const allAnswerContents = [];
        
        questionHistory.forEach((question) => {
            const selectedOptions = question.options.filter(opt => opt.select);
            if (selectedOptions.length > 0) {
                allQuestionIds.push(question.question_id);
                const answerIndices = selectedOptions.map(opt => opt.index);
                allAnswerContents.push(answerIndices.join(','));
            }
        });
        
        // 检查是否所有题目都已作答
        if (allQuestionIds.length !== questionHistory.length) {
            alert("Please answer all questions before submitting.");
            return;
        }

        let userInfo = localStorage.getItem("initUser");
        let userJson = JSON.parse(userInfo);
        var userId = userJson["user_id"];

        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("questionIds", allQuestionIds.join(';'));
        formData.append("answerContents", allAnswerContents.join(';'));
        formData.append("sceneType", "1");

        this.setState({ isSubmitting: true });

        postFormData("/answerQuestion", formData)
            .then(response => {
                if (response && response["success"] === true) {
                    // 保存提交日期到 localStorage
                    const today = new Date().toDateString();
                    localStorage.setItem("questionSubmitDate", today);
                    
                    // 提交成功后，更新状态
                    this.setState({
                        hasSubmittedToday: true,
                        lastSubmitDate: today,
                        isSubmitting: false,
                        answerQuestionIds: [],
                        answerContents: []
                    });
                    
                    alert("Submission successful! Come back tomorrow for more questions.");
                } else {
                    console.error("提交失败:", response);
                    this.setState({ isSubmitting: false });
                    alert("Submission failed. Please try again.");
                }
            })
            .catch(error => {
                console.error("数据提交失败:", error);
                this.setState({ isSubmitting: false });
                alert("Submission failed. Please try again.");
            });
    }

    renderQuestionItem = (question, index) => {
        const { currentQuestionIndex, questionHistory, isSubmitting, hasSubmittedToday } = this.state;
        const isLastQuestion = currentQuestionIndex === questionHistory.length - 1;
        const isFirstQuestion = currentQuestionIndex === 0;
        const hasSelection = question.options.some((opt) => opt.select);

        return (
            <div className="questionCard">
                <div className="questionProgress">
                    <div className="questionProgressRow">
                        <span className="questionProgressText">
                            Question {currentQuestionIndex + 1} of {questionHistory.length}
                        </span>
                        <span className="questionTypeBadge" title={question.question_type_name}>
                            {Number(question.question_type) === 1 ? 'Single Choice' : 'Multiple Choice'}
                        </span>
                    </div>
                    <div className="progressBar">
                        <div
                            className="progressFill"
                            style={{ width: `${((currentQuestionIndex + 1) / questionHistory.length) * 100}%` }}
                        ></div>
                    </div>
                </div>

                <p className="questionTitle">{question.title}</p>

                <div className="questionOptions">
                    {question.options.map((option, optIndex) => (
                        <div
                            key={optIndex}
                            className={`questionOption ${option.select ? 'selected' : ''}`}
                            onClick={() => this.handleOptionClick(index, optIndex)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    this.handleOptionClick(index, optIndex);
                                }
                            }}
                        >
                            <span className="questionOptionKey" aria-hidden>
                                {String.fromCharCode(65 + optIndex)}
                            </span>
                            <span className="questionOptionLabel">{option.title}</span>
                        </div>
                    ))}
                </div>

                <div className="questionNavigation">
                    {!isFirstQuestion && (
                        <button className="navButton prevButton" onClick={this.goToPreviousQuestion}>
                            ← Previous
                        </button>
                    )}
                    {!isLastQuestion && (
                        <button
                            type="button"
                            className="navButton nextButton"
                            onClick={this.goToNextQuestion}
                            disabled={!hasSelection}
                        >
                            Next →
                        </button>
                    )}
                    {isLastQuestion && (
                        <button
                            type="button"
                            className="navButton submitButton"
                            onClick={this.submitAnswers}
                            disabled={!hasSelection}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { questionHistory, currentQuestionIndex, loading, hasSubmittedToday } = this.state;

        // 如果今天已经提交过，展示明天再来
        if (hasSubmittedToday) {
            return (
                <div className="mineContainer questionTabRoot">
                    <div className="completedTodayState">
                        <div className="completedIcon">🎉</div>
                        <p className="completedTitle">✓ Today's Questions Completed</p>
                        <p className="completedSubTitle">Come back tomorrow for more questions!</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="mineContainer questionTabRoot">
                {loading ? (
                    <div className="loadingState">
                        <div className="spinner"></div>
                        <p>Loading questions...</p>
                    </div>
                ) : questionHistory.length > 0 ? (
                    <div className="questionCardContainer">
                        {this.renderQuestionItem(questionHistory[currentQuestionIndex], currentQuestionIndex)}

                        {/* 题目指示器 */}
                        <div className="questionIndicators">
                            {questionHistory.map((_, index) => (
                                <div
                                    key={index}
                                    className={`indicator ${index === currentQuestionIndex ? 'active' : ''} ${
                                        questionHistory[index].options.some(opt => opt.select) ? 'answered' : ''
                                    }`}
                                    onClick={() => this.setState({ currentQuestionIndex: index })}
                                ></div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="emptyState">
                        <img src={require('../../assets/tool/workTestImg.png')} alt="Questions" />
                        <p className="emptyTitle">No Questions Yet</p>
                        <p className="emptySubTitle">Your answered questions will appear here.</p>
                    </div>
                )}
            </div>
        );
    }
}

export default QuestionTabView;
